import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import swal from 'sweetalert';
import { Select, Modal, Popover, Alert } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import axios from 'axios';
import api from '../../config.json'
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import validation from '../../utill/validation';
import Joi from 'joi';
import Loading from '../../utill/LoadingComponent';
import { cloneDeep, isArray } from 'lodash';
import FileUpload from './FIleUpload';
import imageCompression from "browser-image-compression";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleDown, faArrowAltCircleUp, faEye, faIcons, faMinusCircle, faPlusCircle, faTimesCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { UploadOutlined } from '@ant-design/icons';
import { Button as AntdButton, message, Upload } from 'antd';
import './ItemForm.css'
const ItemForm = ({ history, RightName, Heading }) => {
    const location = useLocation()
    const [listNames, setAllListNames] = useState([]);
    const [listData, setListData] = useState([]);
    const [RuleData, setRuleData] = useState([]);
    const [pmsCompList, setPMSCompList] = useState([]);

    const [customerList, setCustomerList] = useState([]);
    const [errors, setErrors] = useState({})
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({ RefDocs: [], Inspection: [], Alerts: [] });
    const [oldObj, setOldObj] = useState({});
    const [files, setFiles] = useState([]);
    const [refrenceCode, setRefCode] = useState("")
    const [allReports, setAllReports] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [uploadList, setUploadList] = useState([]);
    const [remarks, setRemarks] = useState({}); // Track remarks for each image
    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState({});
    const [selectedDay, setSelectedDay] = useState([]);
    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    useEffect(() => {
        getAllListNames();
        getAllCustomer();
        getAllList();
        GetAllRules();
        if (location.state && location.state.action == 'edit') {
            setOldObj(location.state.data)
            GetAllInspetcionTypes1(location.state.data)
        } else {
            GetAllInspetcionTypes()
        }
    }, [location])

    useEffect(() => {
        Heading('Item Master Form')
        getPMSCompList();
    }, [])


    const getPMSCompList = () => {
        axios.get(api.api + "GetComponents")
            .then((result) => {
                setPMSCompList(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const schema = {
        StartSession: Joi.object(),
        InSession: Joi.object(),
        EndSession: Joi.object(),
        ItemName: Joi.string().required(),
        ItemNumber: Joi.string().required(),
        CustomerName: Joi.string().optional(),
        Operation: Joi.string().required(),
        Inspection: Joi.array(),
        EnableNotification: Joi.boolean(),
        RefDocs: Joi.array(),
        Session: Joi.any(),
        Files: Joi.array(),
        Alerts: Joi.array(),
        _id: Joi.string()

    }




    const getAllListNames = () => {
        axios.get(api.api + "checkSheetMaster")
            .then((result) => {
                result.data = result.data.sort((a, b) => {
                    if (a.check_sheet_title < b.check_sheet_title) {
                        return -1;
                    }
                    if (a.check_sheet_title > b.check_sheet_title) {
                        return 1;
                    }
                    return 0;
                });
                const all = result.data.map((one) => { return { name: one.check_sheet_title, label: `${one.check_sheet_title} / ${one.Version}`, id: one._id, value: one.check_sheet_title, version: one.Version } })
                setAllListNames(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const getAllCustomer = () => {
        axios.get(api.api + "customer")
            .then((result) => {
                const all = result.data.map((one) => { return { label: one.Customer, value: one.Customer } })
                setCustomerList(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    async function fileFromBase64(base64, fileName) {
        try {
            // Split the base64 string to get the metadata part (before the comma)
            const base64Parts = base64.split(',');

            // Extract the MIME type from the first part of the base64 string (e.g., "data:image/png;base64")
            const mimeMatch = base64Parts[0].match(/:(.*?);/);
            const fileType = mimeMatch ? mimeMatch[1] : ''; // Extract the MIME type

            // Decode the base64 string to a binary string
            const binaryString = window.atob(base64Parts[1]);

            // Create a Uint8Array to store the binary data
            const len = binaryString.length;
            const bytes = new Uint8Array(len);

            // Map the binary string data to the Uint8Array
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            // Create a Blob from the array buffer
            const blob = new Blob([bytes], { type: fileType });

            // Create a File object from the Blob
            const file = new File([blob], fileName, { type: fileType });

            return file;
        } catch (error) {
            console.error('Error converting base64 to file:', error);
            return null;
        }
    }

    const loadFilesFromUrls = async (all = []) => {
        const processFiles = all.filter(x => x.FilePath)
        let validFiles = []
        if (processFiles.length > 0) {
            const fileListPromises = processFiles.map((file) => fileFromBase64(file.FilePath, file.DocTitle));
            const fetchedFiles = await Promise.all(fileListPromises);
            // Filter out any null files in case of errors during fetch
            validFiles = fetchedFiles.filter((file) => file !== null);

        }
        return [...all.filter(x => !x.FilePath), ...validFiles]

    };



    const handleUpdate = async () => {
        delete formData.__v
        delete formData.createdAt
        delete formData.updatedAt
        setLoader(true)
        const formData1 = new FormData();
        const files = await loadFilesFromUrls(formData.RefDocs)
        formData1.append('Data', JSON.stringify({ old: oldObj, new: formData }));

        const largeFiles = formData.RefDocs.filter(file => file.size / 1024 > 1024); // convert bytes to KB

        // Function to compress images
        const compressImage = async (file) => {
            const options = {
                maxSizeMB: 0.9, // Compress to a maximum size of 512KB
                maxWidthOrHeight: 1920, // Maintain reasonable dimensions
                useWebWorker: true,
            };
            try {
                const compressedFile = await imageCompression(file, options);
                return compressedFile;
            } catch (error) {
                console.error("Error compressing image:", error);
                return file; // Return original file if compression fails
            }
        };

        if (largeFiles.length > 0) {
            // Open Ant Design Modal for confirmation if there are large files
            setLoader(false)
            Modal.confirm({
                title: "Large File Detected",
                content: "Some files exceed 512KB. Would you like to compress them automatically?",
                async onOk() {
                    // Compress large files before uploading
                    for (const file of files) {
                        const compressedFile = file.size / 1024 > 512 ? await compressImage(file) : file;
                        formData1.append("files", compressedFile);
                    }
                    setLoader(true)
                    axios.patch(api.api + 'item/' + formData._id, formData1)
                        .then((result) => {
                            swal('Update Successfully');
                            history.push('/setting/item/list');
                            setLoader(false)
                        })
                        .catch((err) => {
                            if (err.response && err.response.data) {
                                if (err.response.data.message) {
                                    swal("ERROR", `${err.response.data.message}`, { dangerMode: true });
                                } else {
                                    swal("ERROR", `${err.response.data}`, { dangerMode: true });
                                }
                            } else {
                                swal(`${err}`);
                            }
                            setLoader(false)
                        })
                },
                onCancel() {
                    swal("Update Cancelled", "The update was cancelled as files exceeded the size limit.", "info");
                },
            });
        } else {
            Array.from(files).forEach(file => {
                formData1.append('files', file);
            });
            axios.patch(api.api + 'item/' + formData._id, formData1)
                .then((result) => {
                    swal('Update Successfully');
                    history.push('/setting/item/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        if (err.response.data.message) {
                            swal("ERROR", `${err.response.data.message}`, { dangerMode: true });
                        } else {
                            swal("ERROR", `${err.response.data}`, { dangerMode: true });
                        }
                    } else {
                        swal(`${err}`);
                    }
                    setLoader(false)
                })
        }

    }

    const handleUpload = async () => {
        const formData1 = new FormData();
        console.log(`Uploading`, fileList, formData1);

        // Check for files that exceed the size limit
        const largeFiles = fileList.filter(file => file.size / 1024 > 512); // convert bytes to KB

        // Function to compress images
        const compressImage = async (file) => {
            const options = {
                maxSizeMB: 0.5, // Compress to a maximum size of 512KB
                maxWidthOrHeight: 1920, // Maintain reasonable dimensions
                useWebWorker: true,
            };
            try {
                const compressedFile = await imageCompression(file, options);
                return compressedFile;
            } catch (error) {
                console.error("Error compressing image:", error);
                return file; // Return original file if compression fails
            }
        };

        if (largeFiles.length > 0) {
            // Open Ant Design Modal for confirmation if there are large files
            Modal.confirm({
                title: "Large File Detected",
                content: "Some files exceed 512KB. Would you like to compress them automatically?",
                async onOk() {
                    // Compress large files before uploading
                    for (const file of fileList) {
                        const compressedFile = file.size / 1024 > 512 ? await compressImage(file) : file;
                        formData1.append("files", compressedFile);
                    }
                    uploadImages(formData1);
                },
                onCancel() {
                    swal("Upload Cancelled", "The upload was cancelled as files exceeded the size limit.", "info");
                },
            });
        } else {
            // Directly proceed if no files exceed the size limit
            fileList.forEach((file) => formData1.append("files", file));
            uploadImages(formData1);
        }
    };

    const uploadImages = (formData) => {
        axios
            .post(api.api + "uploadImage", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => {
                swal("Save Successfully");
                // getAllImages();
                setOpen(false);
            })
            .catch((err) => {
                if (err.response && err.response.data) {
                    swal("ERROR", `${err.response.data}`, { dangerMode: true });
                } else {
                    swal(`${err}`);
                }
            });
    };
    const handleSave = () => {
        delete formData.__v
        delete formData.createdAt
        delete formData.updatedAt
        const error = validation.validate(formData, schema)
        if (error) {
            setErrors(error)
            return
        }
        setErrors(error || {})
        setLoader(true)
        // formData.Files = files
        console.log(formData, "lkkjsdlkjsldk")
        const formData1 = new FormData();
        formData1.append('Data', JSON.stringify(formData));
        const largeFiles = formData.RefDocs.filter(file => file.size / 1024 > 1024); // convert bytes to KB

        // Function to compress images
        const compressImage = async (file) => {
            const options = {
                maxSizeMB: 0.9, // Compress to a maximum size of 512KB
                maxWidthOrHeight: 1920, // Maintain reasonable dimensions
                useWebWorker: true,
            };
            try {
                const compressedFile = await imageCompression(file, options);
                return compressedFile;
            } catch (error) {
                console.error("Error compressing image:", error);
                return file; // Return original file if compression fails
            }
        };

        if (largeFiles.length > 0) {
            // Open Ant Design Modal for confirmation if there are large files
            Modal.confirm({
                title: "Large File Detected",
                content: "Some files exceed 512KB. Would you like to compress them automatically?",
                async onOk() {
                    // Compress large files before uploading
                    for (const file of formData.RefDocs) {
                        const compressedFile = file.size / 1024 > 512 ? await compressImage(file) : file;
                        formData1.append("files", compressedFile);
                    }
                    uploadImages(formData1);
                },
                onCancel() {
                    swal("Upload Cancelled", "The upload was cancelled as files exceeded the size limit.", "info");
                },
            });
        } else {
            // Directly proceed if no files exceed the size limit
            Array.from(formData.RefDocs).forEach(file => {
                formData1.append('files', file);
            });
        }

        axios.post(api.api + 'item', formData1,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then((result) => {
                swal('Save Successfully');
                history.push('/setting/item/list');
                setLoader(false)
            })
            .catch((err) => {
                if (err.response && err.response.data) {
                    if (err.response.data.message) {
                        swal("ERROR", `${err.response.data.message}`, { dangerMode: true });
                    } else {
                        swal("ERROR", `${err.response.data}`, { dangerMode: true });
                    }
                } else {
                    swal(`${err}`);
                }

                setLoader(false)
            })
    }




    const handleFileChange = (event) => {
        setFiles([...files, ...event.target.files]);
    };

    const handleRemoveFile = (indexToRemove) => {
        setFiles(files.filter((_, index) => index !== indexToRemove));
    };

    const handleOnChange = (e) => {
        const obj = { ...formData }
        const { name, value } = e.currentTarget;
        obj[name] = value;
        const error = validation.validateProperty(e.currentTarget, schema);
        setErrors(error || {})
        setFormData(obj);
        console.log(obj);
    }

    const handleOnChangeTriggerEvent = (name, value, indpectionIdx, triggerIdx) => {
        const obj = { ...formData };
        if (obj.Inspection[indpectionIdx] && obj.Inspection[indpectionIdx]["TriggerEvent"]) {
            obj.Inspection[indpectionIdx]["TriggerEvent"][triggerIdx][name] = value;
        } else {
            obj.Inspection[indpectionIdx]["TriggerEvent"] = [{ [name]: value }]
        }
        setFormData(obj);
    };
    const operations = (Component) =>
        pmsCompList
            ?.find(one => one.ComponentId === Component)
            ?.Operation
            ?.map(one => ({
                label: one.OperationID,
                value: one.OperationID
            })) || [];

    const handleOnChangeInspection = (propertyName, name, value, idx, setname) => {
        const obj = { ...formData };

        if (setname === 'SetName') {
            // Initialize SetNames array if it doesn't exist for the current report
            if (!obj.Inspection[idx].SetNames) {
                obj.Inspection[idx].SetNames = [];
            }

            // Extract the set number from the name (e.g., SetName1, SetName2)
            const setIndex = parseInt(name.replace('SetName', ''), 10) - 1;

            // Ensure the array has enough slots for the sets
            obj.Inspection[idx].SetNames[setIndex] = {
                setName: `SetName${setIndex + 1}`,
                value: value
            };
        } else if (obj.Inspection[idx] && obj.Inspection[idx]["InspectionName"]) {
            obj.Inspection[idx][name] = value;
        } else {
            obj.Inspection[idx] = { InspectionName: propertyName, [name]: value };
        }
        if (name == "TriggerBy" && value) {
            if (!obj.Inspection[idx]["TriggerEvent"]) {
                obj.Inspection[idx]["TriggerEvent"] = [{}]
            } else {
                obj.Inspection[idx]["TriggerEvent"].push({})
            }

        }

        if (name == "Periodicity") {
            if ((value == "DateRange")) {

                obj.Inspection[idx]["PeriodicityRange"] = [{ From: new Date(), Till: new Date() }]
            }
            if ((value == "Daily")) {
                obj.Inspection[idx]["PeriodicityRange"] = [{ From: moment().format('HH:mm'), Till: moment().format('HH:mm') }]
            }
        }
        setFormData(obj);
    };

    const handleOnChangeInspectionCheckSheet = (name, value, idx, sheetIdx) => {
        const obj = { ...formData };
        if (obj.Inspection[idx] && obj.Inspection[idx].checkSheetTitle) {
            if (obj.Inspection[idx].checkSheetTitle[sheetIdx]) {
                obj.Inspection[idx].checkSheetTitle[sheetIdx][name] = value
            } else {
                obj.Inspection[idx].checkSheetTitle[sheetIdx].push({ [name]: value })
            }
        }
        setFormData(obj);
    };

    const handleOnChangeCustomField = (idx, fieldIdx, e, arrayKey) => {
        const updatedFormData = { ...formData };

        if (e === 'SessionName' || e === 'StartSession' || e === 'EndSession' || e === 'InSession') {
            if (e == "SessionName") {
                updatedFormData.Alerts[idx]["Name"] = fieldIdx;
                setFormData(updatedFormData);
            } else {
                const sessionKey = e; // Determine the session key
                let updateValue = {};

                // Set the corresponding value based on the arrayKey
                if (arrayKey === 'DateTime') {
                    updateValue = { DateTime: fieldIdx };
                } else if (arrayKey === 'Periodicity' && e === 'InSession') {
                    updateValue = { Periodicity: Number(fieldIdx) };
                } else {
                    updateValue = { InspectionName: fieldIdx };
                }

                // Update the session object, preserving existing values
                updatedFormData.Alerts[idx][sessionKey] = {
                    ...updatedFormData.Alerts[idx][sessionKey],
                    ...updateValue,
                };
            }

        } else {
            // Update the formData for the Inspection array
            updatedFormData.Inspection[idx][arrayKey][fieldIdx][e.target.name] = e.target.value;
        }

        setFormData(updatedFormData);
    };


    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'customInspection')
            .then((result) => {
                console.log(result, "csoduvifd")
                const reports = [...reportType]
                const obj1 = { ...formData }
                result.data.forEach((one) => {
                    const cloneObj = cloneDeep(one)

                    one.CustomFields = one.CustomFields.filter(x => (x.DataType == 'list') || (x.DataType == 'time_based_input'))
                    one.CustomFields = one.CustomFields.map(x => { return { FieldName: x.FieldName, DataType: x.DataType, EnableMultiSelect: false } })

                    one.ConstantFields = cloneObj.CustomFields.filter(x => x.Constant)
                    one.ConstantFields = one.ConstantFields.map(x => { return { DataType: x.DataType, FieldName: x.FieldName, DisplayForDataEntry: false, Value: null } })

                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType, CustomFields: one.CustomFields, ConstantFields: one.ConstantFields }
                    reports.push(obj)
                })
                reports.forEach((one) => {
                    obj1.Inspection.push({ InspectionName: one.label, Enable: false, CustomFields: one.CustomFields, ConstantFields: one.ConstantFields, checkSheetTitle: [{}] })
                })
                // obj1.Inspection=reports
                setAllReports(reports)
                setFormData(obj1)
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const GetAllInspetcionTypes1 = (data1) => {
        axios.get(api.api + 'customInspection')
            .then((result) => {
                const reports = [...reportType]
                const obj1 = { ...formData }
                result.data.forEach((one) => {
                    const cloneObj = cloneDeep(one)

                    one.CustomFields = one.CustomFields.filter(x => x.DataType == 'list' || x.DataType == 'time_based_input')
                    console.log(one.CustomFields, "vsdhvbhs", one)

                    one.CustomFields = one.CustomFields.map(x => { return { FieldName: x.FieldName, EnableMultiSelect: false, DataType: x.DataType } })

                    one.ConstantFields = cloneObj.CustomFields.filter(x => x.Constant)
                    one.ConstantFields = one.ConstantFields.map(x => { return { DataType: x.DataType, FieldName: x.FieldName, DisplayForDataEntry: false, Value: null } })

                    const prevDataIdx = data1.Inspection.findIndex(x => x.InspectionName == one.InspectionType);
                    if (prevDataIdx >= 0 && data1.Inspection[prevDataIdx]) {
                        let arrCustomField = [];
                        let arrConstantField = []
                        one.ConstantFields.forEach(y => {
                            data1.Inspection[prevDataIdx].ConstantFields.forEach((c) => {
                                if (y.FieldName == c.FieldName) {
                                    arrConstantField.push(c)
                                }
                            })
                        })
                        one.CustomFields.forEach(y => {
                            data1.Inspection[prevDataIdx].CustomFields.forEach((c) => {
                                if (y.FieldName == c.FieldName) {
                                    c.DataType = y.DataType;
                                    arrCustomField.push(c)
                                }
                            })
                        })
                        data1.Inspection[prevDataIdx].CustomFields = arrCustomField;
                        data1.Inspection[prevDataIdx].ConstantFields = arrConstantField;
                    }

                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType, CustomFields: one.CustomFields, ConstantFields: one.ConstantFields }
                    reports.push(obj)
                })
                reports.forEach((one) => {
                    obj1.Inspection.push({ InspectionName: one.label, Enable: false, CustomFields: one.CustomFields, ConstantFields: one.ConstantFields })
                })
                // obj1.Inspection=reports
                // setAllReports(reports)
                // setFormData(obj1)
                // Example usage:


                const mergedResult = mergeInspections(obj1.Inspection, data1.Inspection);
                console.log(mergedResult);
                data1.Inspection = mergedResult.sort((a, b) => b.Enable - a.Enable)
                console.log(reports, obj1, "current data", mergedResult, data1)
                // obj1.Inspection =mergedResult
                setFormData(data1)
                // return obj1
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const mergeInspections = (firstArray, secondArray) => {
        const mergedArray = firstArray.map((item, idx) => ({ ...item }));

        secondArray.forEach((secondItem) => {
            const index = mergedArray.findIndex(firstItem => firstItem.InspectionName === secondItem.InspectionName);

            if (index !== -1) {
                // Merge Enable field
                mergedArray[index].Enable = secondItem.Enable || mergedArray[index].Enable;
                mergedArray[index].NumOfSamples = secondItem.NumOfSamples || mergedArray[index].NumOfSamples;
                mergedArray[index].QRCodeId = secondItem.QRCodeId || mergedArray[index].QRCodeId;
                mergedArray[index].SetNames = secondItem.SetNames || mergedArray[index].SetNames;
                mergedArray[index].NumberOfSet = secondItem.NumberOfSet || mergedArray[index].NumberOfSet;
                mergedArray[index].EnableSet = secondItem.EnableSet || mergedArray[index].EnableSet;

                mergedArray[index].TriggerBy = secondItem.TriggerBy || mergedArray[index].TriggerBy;
                mergedArray[index].TriggerEvent = secondItem.TriggerEvent || mergedArray[index].TriggerEvent;

                mergedArray[index].InputType = secondItem.InputType || mergedArray[index].InputType;
                mergedArray[index].RefrenceCode = secondItem.RefrenceCode || mergedArray[index].RefrenceCode;
                mergedArray[index].RefSpecimen = secondItem.RefSpecimen || mergedArray[index].RefSpecimen;
                mergedArray[index].CodeRelation = secondItem.CodeRelation || mergedArray[index].CodeRelation;

                mergedArray[index].PeriodicInspection = secondItem.PeriodicInspection || mergedArray[index].PeriodicInspection;
                mergedArray[index].Periodicity = secondItem.Periodicity || mergedArray[index].Periodicity;
                mergedArray[index].PeriodicityRange = secondItem.PeriodicityRange || mergedArray[index].PeriodicityRange;

                // Merge CustomFields
                const updatedCustomFields = [...mergedArray[index].CustomFields];

                secondItem.CustomFields.forEach((customField) => {
                    const fieldIndex = updatedCustomFields.findIndex(firstField => firstField.FieldName === customField.FieldName);

                    if (fieldIndex !== -1) {
                        // Update existing CustomField
                        updatedCustomFields[fieldIndex] = {
                            ...updatedCustomFields[fieldIndex],
                            DataType: customField.DataType !== null ? customField.DataType : updatedCustomFields[fieldIndex].DataType,
                            EnableMultiSelect: customField.EnableMultiSelect !== undefined ? customField.EnableMultiSelect : updatedCustomFields[fieldIndex].EnableMultiSelect,
                            ListName: customField.ListName !== null ? customField.ListName : updatedCustomFields[fieldIndex].ListName,
                        };
                    } else {
                        // Add new CustomField
                        updatedCustomFields.push(customField);
                    }
                });

                mergedArray[index].CustomFields = updatedCustomFields;

                // Merge ConstantFields based on FieldName
                const updatedConstantFields = [...mergedArray[index].ConstantFields];

                secondItem.ConstantFields.forEach((constantField) => {
                    const fieldIndex = updatedConstantFields.findIndex(firstField => firstField.FieldName === constantField.FieldName);

                    if (fieldIndex !== -1) {
                        // If the field exists, update its values
                        updatedConstantFields[fieldIndex] = {
                            ...updatedConstantFields[fieldIndex],
                            DataType: constantField.DataType !== null ? constantField.DataType : updatedConstantFields[fieldIndex].DataType,
                            DisplayForDataEntry: constantField.DisplayForDataEntry !== undefined ? constantField.DisplayForDataEntry : updatedConstantFields[fieldIndex].DisplayForDataEntry,
                            Value: constantField.Value !== null ? constantField.Value : updatedConstantFields[fieldIndex].Value,
                        };
                    } else {
                        // If the field doesn't exist, add it to ConstantFields
                        updatedConstantFields.push(constantField);
                    }
                });

                mergedArray[index].ConstantFields = updatedConstantFields;

                // Merge checkSheetTitle data
                if (secondItem.checkSheetTitle) {
                    mergedArray[index].checkSheetTitle = [
                        ...secondItem.checkSheetTitle
                        // _id: secondItem.checkSheetTitle._id || mergedArray[index].checkSheetTitle?._id,
                        // TemplateName: secondItem.checkSheetTitle.TemplateName || mergedArray[index].checkSheetTitle?.TemplateName,
                        // Version: secondItem.checkSheetTitle.Version || mergedArray[index].checkSheetTitle?.Version,
                        // check_sheet_title: secondItem.checkSheetTitle.check_sheet_title || mergedArray[index].checkSheetTitle?.check_sheet_title,
                        // checkpoints: secondItem.checkSheetTitle.checkpoints || mergedArray[index].checkSheetTitle?.checkpoints,
                        // createdAt: secondItem.checkSheetTitle.createdAt || mergedArray[index].checkSheetTitle?.createdAt,
                        // updatedAt: secondItem.checkSheetTitle.updatedAt || mergedArray[index].checkSheetTitle?.updatedAt,
                    ];
                }
            } else {
                // If no matching item exists, push the new item from secondArray
                mergedArray.push(secondItem);
            }
        });

        return mergedArray;
    };




    const GetAllRules = () => {
        axios.get(api.api + 'RuleMaster')
            .then((result) => {
                // consol(result.data)
                setRuleData(result.data);
            })
            .catch((err) => {
                swal(`${err}`)
                setLoader(false)
            })
    }

    const getAllList = () => {
        axios.get(api.api + "ListMaster")
            .then((result) => {
                const all = result.data.map((one) => { return { label: one.ListName, value: one.ListName } })
                setListData(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const onChangeFile = (idx, sheetIdx) => {
        const obj = { ...formData }
        let link = document.createElement('input');
        link.setAttribute('type', 'file');
        link.setAttribute('accept', 'image/*'); // Restrict to image files only
        link.setAttribute('name', 'ImageFile');

        document.body.appendChild(link);
        link.click();

        link.onchange = async function (e) {
            e.preventDefault();
            const file = e.currentTarget.files[0];
            if (file) {
                let fr = new FileReader();
                fr.readAsDataURL(file); // Reads file as Data URL for images
                fr.onloadend = async function (e) {
                    const imageData = e.target.result; // Base64 string of the image
                    // Perform any operations you need with the image data here
                    const obj = { ...formData };
                    if (obj.Inspection[idx] && obj.Inspection[idx].checkSheetTitle) {
                        if (obj.Inspection[idx].checkSheetTitle[sheetIdx]) {
                            obj.Inspection[idx].checkSheetTitle[sheetIdx]["Drawing"] = imageData
                        } else {
                            obj.Inspection[idx].checkSheetTitle[sheetIdx].push({ "Drawing": imageData })
                        }
                    }
                    setFormData(obj);
                    // Optionally send image data to the server
                };
            }



        };

        document.body.removeChild(link);
    };



    const getPeriodicityInput = (inspection, idx) => {
        if (inspection.Periodicity == "DateRange") {
            return inspection["PeriodicityRange"] && inspection["PeriodicityRange"].map((one, index) => {

                return <div className='d-flex'>
                    <div className="mb-3 d-flex">
                        <label htmlFor="fromDate" className="form-label mt-1">
                            From
                        </label>
                        <input
                            value={moment(formData.Inspection[idx]["PeriodicityRange"][index].From).format("YYYY-MM-DD")}
                            onChange={(e) => {
                                const obj = { ...formData }
                                obj.Inspection[idx]["PeriodicityRange"][index][e.currentTarget.name] = new Date(e.currentTarget.value);
                                setFormData(obj)
                            }}
                            id="fromDate"
                            name="From"
                            className="form-control form-control-sm ml-1"
                            type="date"
                        />
                    </div>
                    <div className="mb-3 d-flex ml-3">
                        <label htmlFor="tillDate" className="form-label mt-1">
                            Till
                        </label>
                        <input
                            value={moment(formData.Inspection[idx]["PeriodicityRange"][index].Till).format("YYYY-MM-DD")}
                            onChange={(e) => {
                                const obj = { ...formData }
                                obj.Inspection[idx]["PeriodicityRange"][index][e.currentTarget.name] = new Date(e.currentTarget.value);
                                setFormData(obj)
                            }}
                            id="tillDate"
                            name="Till"
                            className="form-control form-control-sm ml-1"
                            type="date"
                        />
                    </div>
                    <div className="mb-3 d-flex ml-2 mt-2">
                        <FontAwesomeIcon onClick={() => {
                            const obj = { ...formData };
                            obj.Inspection[idx]["PeriodicityRange"].push({ From: new Date(), Till: new Date() })
                            setFormData(obj)
                        }} color='#007bff' icon={faPlusCircle} />
                        {index > 0 && <FontAwesomeIcon className='ml-2' onClick={() => {
                            const obj = { ...formData };
                            obj.Inspection[idx]["PeriodicityRange"] = obj.Inspection[idx]["PeriodicityRange"].filter((x, i) => i !== index)
                            setFormData(obj)
                        }} color='#007bff' icon={faMinusCircle} />}
                    </div>
                </div>
            })
        }
        if (inspection.Periodicity == "Weekly") {
            return <div className="week-days d-flex mt-2">
                {days.map((day) => (
                    <div
                        style={formData.Inspection[idx]["PeriodicityRange"] && formData.Inspection[idx]["PeriodicityRange"].includes(day) ? { color: 'white' } : {}}
                        key={day}
                        className={`day ${formData.Inspection[idx]["PeriodicityRange"] && formData.Inspection[idx]["PeriodicityRange"].includes(day) ? "selected" : ""}`}
                        onClick={() => {
                            const obj = { ...formData }
                            if (obj.Inspection[idx] && obj.Inspection[idx]["PeriodicityRange"]) {
                                if (obj.Inspection[idx]["PeriodicityRange"].includes(day)) {
                                    obj.Inspection[idx]["PeriodicityRange"] = obj.Inspection[idx]["PeriodicityRange"].filter(x => x !== day);
                                } else {
                                    obj.Inspection[idx]["PeriodicityRange"].push(day);
                                }
                            } else {
                                obj.Inspection[idx]["PeriodicityRange"] = [day];
                            }
                            setFormData(obj);
                        }}
                    >
                        {day[0]}
                    </div>
                ))}
            </div>
        }
        if (inspection.Periodicity == "Daily") {
            return inspection["PeriodicityRange"] && inspection["PeriodicityRange"].map((one, index) => {
                return <div className='d-flex'>
                    <div className="mb-3 d-flex">
                        <label htmlFor="fromDate" className="form-label mt-1">
                            From
                        </label>
                        <input
                            value={formData.Inspection[idx]["PeriodicityRange"][index].From || ""}
                            onChange={(e) => {
                                const obj = { ...formData }
                                obj.Inspection[idx]["PeriodicityRange"][index][e.currentTarget.name] = e.currentTarget.value;
                                setFormData(obj)
                            }}
                            id="fromDate"
                            name="From"
                            className="form-control form-control-sm ml-1"
                            type="time"
                        />
                    </div>
                    <div className="mb-3 d-flex ml-3">
                        <label htmlFor="tillDate" className="form-label mt-1">
                            Till
                        </label>
                        <input
                            value={formData.Inspection[idx]["PeriodicityRange"][index].Till || ""}
                            onChange={(e) => {
                                const obj = { ...formData }
                                obj.Inspection[idx]["PeriodicityRange"][index][e.currentTarget.name] = e.currentTarget.value;
                                setFormData(obj)
                            }}
                            id="tillDate"
                            name="Till"
                            className="form-control form-control-sm ml-1"
                            type="time"
                        />
                    </div>
                    <div className="mb-3 d-flex ml-3 mt-2">
                        <FontAwesomeIcon onClick={() => {
                            const obj = { ...formData };
                            obj.Inspection[idx]["PeriodicityRange"].push({ From: moment().format('HH:mm'), Till: moment().format('HH:mm') })
                            setFormData(obj)
                        }} color='#007bff' icon={faPlusCircle} />
                        {index > 0 && <FontAwesomeIcon className='ml-2' onClick={() => {
                            const obj = { ...formData };
                            obj.Inspection[idx]["PeriodicityRange"] = obj.Inspection[idx]["PeriodicityRange"].filter((x, i) => i !== index)
                            setFormData(obj)
                        }} color='#007bff' icon={faMinusCircle} />}
                    </div>
                </div>
            })
        }
    }

    const getPMSTriggerInputType = (event, idx, sheetIdx) => {
        if (event.Event == "PMSStartJob") {
            return <>
                {/* Runtime with checkbox */}
                <div className='col-sm-4 mt-3 d-flex align-items-center'>
                    <input
                        type="checkbox"
                        checked={event.RuntimeChecked}
                        onChange={(e) =>
                            handleOnChangeTriggerEvent("RuntimeChecked", e.target.checked, idx, sheetIdx)
                        }
                        className='me-2'
                    />
                    <label className='me-2 small'>Runtime (mins)</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter runtime"
                        value={event.Runtime || ""}
                        onChange={(e) =>
                            handleOnChangeTriggerEvent("Runtime", e.target.value, idx, sheetIdx)
                        }
                        style={{ maxWidth: "150px" }}
                    />
                </div>

                {/* Cycles with checkbox */}
                <div className='col-sm-4 mt-3 d-flex align-items-center'>
                    <input
                        type="checkbox"
                        checked={event.CyclesChecked}
                        onChange={(e) =>
                            handleOnChangeTriggerEvent("CyclesChecked", e.target.checked, idx, sheetIdx)
                        }
                        className='me-2'
                    />
                    <label className='me-2 small'>Cycles</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter cycles"
                        value={event.Cycles || ""}
                        onChange={(e) =>
                            handleOnChangeTriggerEvent("Cycles", e.target.value, idx, sheetIdx)
                        }
                        style={{ maxWidth: "150px" }}
                    />
                </div>
            </>
        } else  {
            return <>
                {/* Runtime with checkbox */}
                <div className='col-sm-4 mt-3 d-flex align-items-center'>
                    <label className='me-2 small'>Time (mins)</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter time"
                        value={event.Time || ""}
                        onChange={(e) =>
                            handleOnChangeTriggerEvent("Time", e.target.value, idx, sheetIdx)
                        }
                        style={{ maxWidth: "150px" }}
                    />
                </div>
            </>
        } 
    }
    return (
        <React.Fragment>
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >Item Master Form</p>
            </div> */}
            {/* <ToastContainer /> */}

            <div className="row">
                <div className="col-sm-3">
                    <div className="form-group text-center">
                        <label className='small'>Item Name</label>
                        <input name='ItemName' value={formData.ItemName} className='form-control form-control-sm' onChange={handleOnChange} type='text' placeholder='Enter part name..' />

                    </div>
                    {errors.ItemName && <div className="alert small alert-danger">{errors['ItemName']}</div>}
                </div>
                <div className="col-sm-3">
                    <div className="form-group text-center">
                        <label className='small'>Item Number</label>
                        <input name='ItemNumber' value={formData.ItemNumber} className='form-control form-control-sm' onChange={handleOnChange} type='text' placeholder='Enter part number..' />
                    </div>
                    {errors.ItemNumber && <div className="alert small alert-danger">{errors['ItemNumber']}</div>}
                </div>
                <div className="col-sm-3">
                    <div className="form-group text-center">
                        <label className='small'>Operation</label>
                        <input name='Operation' value={formData.Operation} className='form-control form-control-sm' onChange={handleOnChange} type='text' placeholder='Enter operation..' />

                    </div>
                    {errors.Operation && <div className="alert small alert-danger">{errors['Operation']}</div>}
                </div>
                <div className='col-sm-3 mt-2 text-center'>
                    <label className='small'>Customer</label>
                    <Select
                        showSearch
                        // maxTagCount='responsive'
                        //mode="multiple"
                        placeholder="Select Customer"
                        value={formData.CustomerName}
                        onChange={(values) => {
                            handleOnChange({ currentTarget: { name: 'CustomerName', value: values } })
                        }}
                        style={{ width: '100%' }}
                        options={customerList}
                    />
                    {errors.CustomerName && <div className="alert small alert-danger">{errors['CustomerName']}</div>}
                </div>

            </div>
            <div className='row ml-2'>
                <div className='col-sm-12'>
                    <div style={{ border: '1px solid black' }} className='mt-2'><div className="row  mt-2">
                        <FileUpload files={formData.RefDocs} getFiles={(files) => {
                            const data = { ...formData }
                            data.RefDocs = files
                            setFormData(data)
                        }} />
                    </div>
                    </div>
                </div>
            </div>
            <div className='row ml-2'>
                <div className="col-sm-12">
                    <div style={{ border: '1px solid black' }} className='mt-2'>
                        <div className="col-sm-12 text-left d-flex flex-start">
                            <h5>Enable Alert</h5>
                            <p className='small pl-2 '>( Define sequence of inspection(s) to be performed and raise alert if non-compliance is detected. )</p>
                        </div>

                        <div className="col-sm-4">
                            <div className="form-group text-left">

                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="EnableNotification"
                                            checked={formData.EnableNotification == true}
                                            onChange={(e) => handleOnChange({ currentTarget: { name: "EnableNotification", value: true } })}
                                        />
                                        &nbsp; &nbsp;
                                        Enable
                                    </label>
                                    <label className="ml-3">
                                        <input
                                            type="radio"
                                            name="EnableNotification"
                                            checked={formData.EnableNotification == false}
                                            onChange={(e) => handleOnChange({ currentTarget: { name: "EnableNotification", value: false } })}
                                        />
                                        &nbsp; &nbsp;
                                        Disable
                                    </label>
                                </div>
                            </div>
                            {errors.SampleSerialUnique && <div className="alert small alert-danger">{errors['SampleSerialUnique']}</div>}
                        </div>
                        {formData.EnableNotification && formData.Alerts && formData.Alerts.map((alert, alertIdx) =>
                            <div className="col-sm-12">

                                {formData.EnableNotification && <Table className='mt-2 small table' bordered >

                                    <tbody>

                                        <tr>
                                            <td className='w-25 align-middle' rowSpan={3}>
                                                Alert Name :
                                                <input style={{ border: 'solid lightgray 1px' }} name='Periodicity'
                                                    value={alert.Name || ""}
                                                    className='form-control form-control-sm'
                                                    onChange={(e) => handleOnChangeCustomField(alertIdx, e.currentTarget.value, 'SessionName')}
                                                    type='text' placeholder='Enter name..' />
                                            </td>
                                            <td>Start of Session</td>

                                            <td >

                                                <Select
                                                    showSearch
                                                    maxTagCount='responsive'
                                                    mode="multiple"
                                                    placeholder="Select Start of Session"
                                                    value={alert.StartSession && alert.StartSession.InspectionName || []}

                                                    onChange={(values, all) => handleOnChangeCustomField(alertIdx, values, "StartSession")}
                                                    style={{ width: '100%' }}


                                                    options={formData.Inspection && formData.Inspection.map(one => {
                                                        return { label: one.InspectionName, value: one.InspectionName }
                                                    })}
                                                />
                                            </td>
                                            <td style={{ backgroundColor: 'none' }} className='text-right'><FontAwesomeIcon onClick={() => {
                                                const obj = { ...formData };
                                                obj.Alerts = obj.Alerts.filter((x, i) => i !== alertIdx);
                                                setFormData(obj);
                                            }} icon={faTrashAlt} color='red' /></td>
                                        </tr>
                                        <tr className='w-100'>

                                            <td className='w-25'>In Session</td>
                                            {/* <td><input  type='datetime-local' name='DateTime'
                                                            onChange={(e) => handleOnChangeCustomField(0,e.currentTarget.value, "InSession",'DateTime')}
                                                            /></td> */}

                                            <td className='w-25'>
                                                <Select
                                                    showSearch
                                                    maxTagCount='responsive'
                                                    mode="multiple"
                                                    placeholder="Select In Session"
                                                    value={alert.InSession && alert.InSession.InspectionName || []}

                                                    onChange={(values, all) => handleOnChangeCustomField(alertIdx, values, "InSession")}

                                                    style={{ width: '100%' }}
                                                    options={formData.Inspection && formData.Inspection.map(one => {
                                                        return { label: one.InspectionName, value: one.InspectionName }
                                                    })}
                                                />
                                            </td>
                                            <td className='w-25' >
                                                Periodicity (min) :
                                                <input name='Periodicity'
                                                    value={alert.InSession && alert.InSession.Periodicity}
                                                    className='form-control form-control-sm'
                                                    onChange={(e) => handleOnChangeCustomField(alertIdx, e.currentTarget.value, 'InSession', "Periodicity")}
                                                    type='number' placeholder='Enter Periodicity..' />

                                            </td>
                                        </tr>
                                        <tr>
                                            <td>End Of Session</td>
                                            <td>
                                                <Select
                                                    showSearch
                                                    maxTagCount='responsive'
                                                    mode="multiple"
                                                    placeholder="Select End Of Session"
                                                    value={alert.EndSession && alert.EndSession.InspectionName || []}
                                                    onChange={(values, all) => handleOnChangeCustomField(alertIdx, values, "EndSession")}
                                                    style={{ width: '100%' }}
                                                    options={formData.Inspection && formData.Inspection.map(one => {
                                                        return { label: one.InspectionName, value: one.InspectionName }
                                                    })}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>}

                            </div >)}
                        {formData.EnableNotification && <div className='col-sm-12 text-right'>
                            <FontAwesomeIcon onClick={() => {
                                const obj = { ...formData }
                                obj.Alerts.push({ StartSession: {}, InSession: {}, EndSession: {} })
                                setFormData(obj)
                            }} size='2x' icon={faPlusCircle} />
                        </div>}
                    </div >

                </div></div>

            <div className='row ml-2'>
                <div className='col-sm-12 '>
                    {formData.Inspection && formData.Inspection
                        //.sort((a, b) => b.Enable - a.Enable) // Sorts by Enable field, putting true values first
                        .map((report, idx) => {
                            report.checkSheetTitle = report.checkSheetTitle && isArray(report.checkSheetTitle) ? report.checkSheetTitle : [{}]
                            return <div style={{ border: '1px solid black', backgroundColor: report.Enable ? "lightgreen" : "" }} className='mt-2'><div className="row  mt-2">
                                <div className="col-sm-3 mt-1">
                                    <div className="form-group text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <label className='fs-4 fw-bolder'>{report.InspectionName}</label>
                                        <input name='Enable' onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.checked, idx)} checked={report.Enable} className='mt-2' type='checkbox' />
                                    </div>
                                    {errors.Enable && <div className="alert small alert-danger">{errors['Enable']}</div>}
                                </div>
                                <div className='col-sm-9'>
                                    {report.checkSheetTitle && isArray(report.checkSheetTitle) && report.checkSheetTitle.map((one, sheetIdx) =>
                                        <div className='row'>
                                            <div className="col-sm-1 mt-2">
                                                <div className="form-group text-center">
                                                    <label className='small'>Set Applicable</label>
                                                    <input onChange={(e) => handleOnChangeInspectionCheckSheet("SetApplicable", e.currentTarget.checked, idx, sheetIdx)} name='SetApplicable' checked={one.SetApplicable ? true : false} type='checkbox' placeholder='Enter sample number..' />

                                                </div>
                                                {errors.SetApplicable && <div className="alert small alert-danger">{errors['SetApplicable']}</div>}
                                            </div>
                                            <div className="col-sm-2 mt-3">
                                                <div className="form-group text-center">
                                                    <label className='small'>Quality Standard</label>
                                                    <input onChange={(e) => handleOnChangeInspectionCheckSheet("NumOfSamples", e.currentTarget.value, idx, sheetIdx)} name='QualityStandard' value={one.NumOfSamples} className='form-control form-control-sm' type='number' placeholder='Enter sample number..' />

                                                </div>
                                                {errors.QualityStandard && <div className="alert small alert-danger">{errors['QualityStandard']}</div>}
                                            </div>
                                            <div className='col-sm-4 mt-3 text-center'>
                                                <label className='small'>Check Sheet / Version</label>
                                                <Select
                                                    showSearch
                                                    // maxTagCount='responsive'
                                                    //mode="multiple"
                                                    placeholder="Select Checksheet"
                                                    value={one.check_sheet_title && listNames.find(x => x.name == one.check_sheet_title) ? listNames.find(x => x.name == one.check_sheet_title).label : []}
                                                    onChange={(values, all) => {
                                                        handleOnChangeInspectionCheckSheet("check_sheet_title", all.name, idx, sheetIdx)
                                                        // handleOnChangeInspection(report.name, "Version", all.version,idx)
                                                    }}
                                                    style={{ width: '100%' }}
                                                    options={listNames}
                                                />
                                                {/* {errors.DataType && <div className="alert small alert-danger">{errors['DataType']}</div>} */}
                                            </div>
                                            <div className='col-sm-2 mt-5 text-center'>
                                                {one.Drawing ? <>
                                                    <div>
                                                        <p color='red'>Drawing
                                                            <Popover
                                                                content={<div><img width={200} height={200} src={one.Drawing} /><br></br><a onClick={() => setSelected({})}>Close</a></div>}
                                                                title="Title"
                                                                trigger="click"
                                                                open={selected.Drawing == one.Drawing}
                                                            />
                                                            <FontAwesomeIcon onClick={() => { setSelected(one) }} className='ml-1' icon={faEye} />
                                                            <FontAwesomeIcon className='ml-1' color='red' onClick={() => {
                                                                const obj = { ...formData }
                                                                obj.Inspection[idx].checkSheetTitle[sheetIdx].Drawing = "";
                                                                setFormData(obj);
                                                            }} icon={faTrashAlt} /></p>
                                                    </div>
                                                </> : <AntdButton onClick={() => onChangeFile(idx, sheetIdx)} icon={<UploadOutlined />}>Drawing</AntdButton>}
                                            </div>
                                            <div className='col-sm-3 mt-5 text-center'>
                                                <FontAwesomeIcon onClick={() => {
                                                    const data = { ...formData };

                                                    if (data.Inspection[idx].checkSheetTitle.length - 1 >= sheetIdx + 1) {
                                                        let repObj = data.Inspection[idx].checkSheetTitle[sheetIdx + 1];
                                                        data.Inspection[idx].checkSheetTitle[sheetIdx] = repObj;
                                                        data.Inspection[idx].checkSheetTitle[sheetIdx + 1] = one;
                                                        setFormData(data)
                                                    } else {
                                                        swal('No More Check Sheet For Shifting to Up')
                                                    }
                                                }} icon={faArrowAltCircleDown} />
                                                <FontAwesomeIcon className='ml-2' onClick={() => {
                                                    const data = { ...formData };
                                                    if (0 <= sheetIdx - 1) {
                                                        let repObj = data.Inspection[idx].checkSheetTitle[sheetIdx - 1];
                                                        data.Inspection[idx].checkSheetTitle[sheetIdx] = repObj;
                                                        data.Inspection[idx].checkSheetTitle[sheetIdx - 1] = one;
                                                        setFormData(data)
                                                    } else {
                                                        swal('No More Check Sheet For Shifting to Up')
                                                    }
                                                }} icon={faArrowAltCircleUp} />
                                                <FontAwesomeIcon className='ml-5' onClick={() => {
                                                    const data = { ...formData };
                                                    data.Inspection[idx].checkSheetTitle.push({})
                                                    setFormData(data)
                                                }} icon={faPlusCircle} />
                                                {report.checkSheetTitle.length > 1 && <FontAwesomeIcon className='ml-2' onClick={() => {
                                                    const data = { ...formData };
                                                    data.Inspection[idx].checkSheetTitle = data.Inspection[idx].checkSheetTitle.filter((x, i) => i !== sheetIdx)
                                                    setFormData(data)
                                                }} icon={faMinusCircle} />}
                                            </div>

                                        </div>)}
                                </div>

                            </div>
                                <div className="row  mt-2">
                                    <div className="col-sm-3 mt-5">
                                        <div className="form-group text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <label className='fs-7 fw-bolder'>Verify Refrence Specimen</label>
                                            <input name='RefSpecimen' onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.checked, idx)} checked={report.RefSpecimen} className='mt-2' type='checkbox' />
                                        </div>
                                        {errors.RefSpecimen && <div className="alert small alert-danger">{errors['RefSpecimen']}</div>}
                                    </div>
                                    <div className='col-sm-4 mt-2 text-center'>
                                        <label className='small'>Input Type</label>
                                        <Select
                                            disabled={!report.RefSpecimen}
                                            showSearch
                                            // maxTagCount='responsive'
                                            //mode="multiple"
                                            placeholder="Select Input"
                                            value={report.InputType}
                                            onChange={(values, all) => {
                                                handleOnChangeInspection(report.name, "InputType", values, idx)
                                                // handleOnChangeInspection(report.name, "Version", all.version,idx)
                                            }}
                                            style={{ width: '100%' }}
                                            options={[{ label: "Scanner Input", value: "ScannerInput" }, { label: "Keyboard Input", value: "KeyboardInput" }]}
                                        />
                                        <div >
                                            <div className="col-sm-12 mt-2">
                                                <label className='fs-8 fw-bolder'>Code Relationship</label>
                                            </div>
                                            <div className="col-sm-12 mt-2">
                                                <div className="form-group ">
                                                    <div>
                                                        <label>
                                                            <input
                                                                disabled={!report.RefSpecimen}
                                                                type="radio"
                                                                name="CodeRelation"
                                                                checked={report.CodeRelation == "OR"}
                                                                onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, "OR", idx)}
                                                            />
                                                            &nbsp; &nbsp;
                                                            OR
                                                        </label>
                                                        <label className="ml-3">
                                                            <input
                                                                disabled={!report.RefSpecimen}
                                                                type="radio"
                                                                name="CodeRelation"
                                                                checked={report.CodeRelation == "AND"}
                                                                onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, "AND", idx)}
                                                            />
                                                            &nbsp; &nbsp;
                                                            AND
                                                        </label>
                                                    </div>
                                                </div>
                                                {errors.CodeRelation && <div className="alert small alert-danger">{errors['CodeRelation']}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 mt-2">
                                        <div className="form-group text-center">
                                            <label className='small'>Refrence Codes</label>
                                            <div className='d-flex'>
                                                <input disabled={!report.RefSpecimen} onChange={(e) => setRefCode(e.currentTarget.value.trim())} name='RefrenceCode' value={refrenceCode} className='form-control form-control-sm' type='text' placeholder='Enter refrence code..' />
                                                {report.RefSpecimen && <button onClick={() => {
                                                    if (refrenceCode) {
                                                        const obj = { ...formData }
                                                        if (obj.Inspection[idx].RefrenceCode) {
                                                            if (obj.Inspection[idx].RefrenceCode.includes(refrenceCode)) {
                                                                swal("Reference code already have in list.", { dangerMode: true })
                                                            } else {
                                                                obj.Inspection[idx].RefrenceCode.push(refrenceCode);
                                                            }
                                                        } else {
                                                            obj.Inspection[idx].RefrenceCode = [refrenceCode];
                                                        }
                                                        setRefCode("")
                                                        setFormData(obj);
                                                    } else {
                                                        swal("Reference code cannot be empty. Please provide a valid reference code.", { dangerMode: true })
                                                    }
                                                }} className='btn btn-sm btn-primary ml-2'>Add</button>}
                                            </div>
                                        </div>
                                        <div>
                                            List Of Reference Codes
                                            <ul
                                                style={{
                                                    listStyleType: "decimal", // Makes the list numbered
                                                    // border: "1px solid black", // Adds border
                                                    padding: "10px", // Adds spacing
                                                    width: "fit-content", // Adjusts border to content size
                                                }}
                                            >
                                                {report.RefrenceCode && report.RefrenceCode.map(item => <li>{item}  <FontAwesomeIcon onClick={() => {
                                                    const obj = { ...formData }
                                                    obj.Inspection[idx].RefrenceCode = obj.Inspection[idx].RefrenceCode.filter(x => x !== item);
                                                    setFormData(obj);
                                                }} className='ml-3' color='red' icon={faTimesCircle} /></li>)}
                                            </ul>
                                        </div>
                                        {errors.RefrenceCode && <div className="alert small alert-danger">{errors['RefrenceCode']}</div>}
                                    </div>

                                </div>
                                <div className="row  mt-2">
                                    <div className="col-sm-3 mt-2">
                                        <div className="form-group text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <label className='fs-7 fw-bolder'>Periodic Inspection</label>
                                            <input name='PeriodicInspection' onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.checked, idx)} checked={report.PeriodicInspection} className='mt-2' type='checkbox' />
                                        </div>
                                        {errors.PeriodicInspection && <div className="alert small alert-danger">{errors['PeriodicInspection']}</div>}
                                    </div>
                                    <div className='col-sm-3 mt-2 text-center'>
                                        <label className='small'>Periodicity</label>
                                        <Select
                                            disabled={!report.PeriodicInspection}
                                            showSearch
                                            // maxTagCount='responsive'
                                            //mode="multiple"
                                            placeholder="Select Periodicity"
                                            value={report.Periodicity}
                                            onChange={(values, all) => {

                                                handleOnChangeInspection(report.name, "Periodicity", values, idx)
                                                // handleOnChangeInspection(report.name, "Version", all.version,idx)
                                            }}
                                            style={{ width: '100%' }}
                                            options={[{ label: "Date Range", value: "DateRange" }, { label: "Weekly", value: "Weekly" }, { label: "Daily", value: "Daily" }]}
                                        />
                                    </div>
                                    {report.Periodicity && <div className="col-sm-4 mt-1 text-center">
                                        <div className="form-group text-center">
                                            <label className='small'>{report.Periodicity && report.Periodicity.replace(/([a-z])([A-Z])/g, "$1 $2")}</label>
                                            <div className='ml-5' >
                                                {report.PeriodicInspection && getPeriodicityInput(report, idx)}
                                            </div>
                                        </div>

                                        {errors.Periodicity && <div className="alert small alert-danger">{errors['Periodicity']}</div>}
                                    </div>}
                                </div>
                                <div className="row  mt-2 ">
                                    <div style={{ paddingTop: 50 }} className="col-sm-2 mt-2 ">
                                        <div className="form-group text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <label className='fs-7 fw-bolder'>PMS Trigger Enable</label>
                                            <input name='TriggerBy' onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.checked, idx)} checked={report.TriggerBy} className='mt-2' type='checkbox' />
                                        </div>
                                        {errors.TriggerBy && <div className="alert small alert-danger">{errors['TriggerBy']}</div>}
                                    </div>
                                    {report.TriggerBy && report.TriggerEvent && report.TriggerEvent.map((event, sheetIdx) => {
                                        return <>
                                            {sheetIdx > 0 && <div style={{ paddingTop: 50 }} className="col-sm-2 mt-2 "></div>}
                                            <div className='col-sm-8'>
                                                <div className='row'>
                                                    <div className='col-sm-4 mt-2 text-center'>
                                                        <label className='small'>Event</label>
                                                        <Select
                                                            // disabled={!report.TriggerBy}
                                                            showSearch
                                                            // maxTagCount='responsive'
                                                            //mode="multiple"
                                                            placeholder="Select Event"
                                                            value={event.Event}
                                                            onChange={(values, all) => {

                                                                handleOnChangeTriggerEvent("Event", values, idx, sheetIdx)
                                                                // handleOnChangeInspection(report.name, "Version", all.version,idx)
                                                            }}
                                                            style={{ width: '100%' }}
                                                            options={[{ label: "PMS Start Job", value: "PMSStartJob" }, { label: "PMS End Job", value: "PMSEndJob" }]}
                                                        />
                                                    </div>
                                                    <div className='col-sm-4 mt-2 text-center'>
                                                        <label className='small'>Component</label>
                                                        <Select
                                                            // disabled={!report.TriggerBy}
                                                            showSearch
                                                            // maxTagCount='responsive'
                                                            //mode="multiple"
                                                            placeholder="Select Component"
                                                            value={event.Component}
                                                            onChange={(values, all) => {

                                                                handleOnChangeTriggerEvent("Component", values, idx, sheetIdx)
                                                                // handleOnChangeInspection(report.name, "Version", all.version,idx)
                                                            }}
                                                            style={{ width: '100%' }}
                                                            options={pmsCompList.map(one => ({ label: one.ComponentId, value: one.ComponentId }))}
                                                        />
                                                    </div>
                                                    <div className='col-sm-4 mt-2 text-center'>
                                                        <label className='small'>Operation</label>
                                                        <Select
                                                            // disabled={!report.TriggerBy}
                                                            showSearch
                                                            // maxTagCount='responsive'
                                                            //mode="multiple"
                                                            placeholder="Select Operation"
                                                            value={event.Operation}
                                                            onChange={(values, all) => {

                                                                handleOnChangeTriggerEvent("Operation", values, idx, sheetIdx)
                                                                // handleOnChangeInspection(report.name, "Version", all.version,idx)
                                                            }}
                                                            style={{ width: '100%' }}
                                                            options={operations(event.Component)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>

                                                    {getPMSTriggerInputType(event, idx, sheetIdx)}

                                                    {/* Cycles with checkbox */}
                                                    <div className='col-sm-4 mt-3 d-flex align-items-center'>
                                                        <label className='me-2 small'>Escalation Time (mins)</label>
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            placeholder="Enter escalation time"
                                                            value={event.EscalationTime || ""}
                                                            onChange={(e) =>
                                                                handleOnChangeTriggerEvent("EscalationTime", e.target.value, idx, sheetIdx)
                                                            }
                                                            style={{ maxWidth: "150px" }}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div style={{ paddingTop: 50 }} className='col-sm-2  text-center'>
                                                <FontAwesomeIcon className='ml-2' onClick={() => {

                                                    const data = { ...formData };
                                                    if (!data.Inspection[idx].TriggerEvent) {
                                                        data.Inspection[idx].TriggerEvent = []
                                                    }
                                                    data.Inspection[idx].TriggerEvent.push({})
                                                    setFormData(data)
                                                }} icon={faPlusCircle} />
                                                {report.TriggerEvent && report.TriggerEvent.length > 1 && <FontAwesomeIcon className='ml-2' onClick={() => {
                                                    const data = { ...formData };
                                                    data.Inspection[idx].TriggerEvent = data.Inspection[idx].TriggerEvent.filter((x, i) => i !== sheetIdx)
                                                    setFormData(data)
                                                }} icon={faMinusCircle} />}
                                            </div>
                                        </>
                                    })}
                                </div>
                                <div className='row p-2'>
                                    <div className='col-sm-12'>
                                        <Table className='mt-2 small table-sm' striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Set Enable</th>
                                                    <th>Number Of Sets</th>
                                                    <th>Sets Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr >
                                                    <td><input onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.checked, idx)} checked={report.EnableSet || false} type='checkbox' name='EnableSet' /></td>
                                                    <td style={{ width: '400px' }}>{report.EnableSet ? <input onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.value, idx)} value={report['NumberOfSet'] || ''} type='number' name='NumberOfSet' style={{ height: '30px' }} /> : <input disabled={true} onChange={(e) => handleOnChangeInspection(report.name, e.currentTarget.name, e.currentTarget.value, idx)} checked={report.NumberOfSet || ''} type='number' name='NumberOfSet' style={{ height: '30px' }} />}</td>
                                                    <td>

                                                        {report.NumberOfSet && report.NumberOfSet > 0 &&
                                                            Array(Number(report.NumberOfSet)).fill(0).map((_, idxx) => (
                                                                <div className='d-flex w-100' key={idxx}>
                                                                    <span className='w-10'>{idxx + 1} :</span>
                                                                    <span className='w-85'>
                                                                        <input
                                                                            onChange={(e) => handleOnChangeInspection(
                                                                                report.name,
                                                                                `SetName${idxx + 1}`,
                                                                                e.currentTarget.value,
                                                                                idx,
                                                                                'SetName'
                                                                            )}
                                                                            value={report.SetNames && report.SetNames[idxx]?.value || ''}
                                                                            type='text'
                                                                            name={`SetName${idxx + 1}`}
                                                                            style={{ height: '30px' }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                            ))
                                                        }
                                                    </td>


                                                </tr>

                                            </tbody>
                                        </Table>

                                        <Table className='mt-2 small table-sm' striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Constant Field</th>
                                                    <th>Display For Data Entry</th>
                                                    <th>Data</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {report.ConstantFields && report.ConstantFields.map((row, index) => (
                                                    <tr key={row.id}>
                                                        <td>{row.FieldName}</td>
                                                        <td><input onChange={(e) => handleOnChangeCustomField(idx, index, { target: { name: "DisplayForDataEntry", value: e.currentTarget.checked } }, "ConstantFields")} checked={row.DisplayForDataEntry || false} type='checkbox' name='DisplayForDataEntry' /></td>
                                                        <td>
                                                            <input value={row.Value} placeholder={`Enter ${row.FieldName}...`} step={row.DataType == "float" ? "0.01" : ""} className='form-control form-control-sm' type={row.DataType == "string" ? "text" : row.DataType} name='Value' onChange={(e) => handleOnChangeCustomField(idx, index, { target: { name: 'Value', value: e.currentTarget.value } }, "ConstantFields")} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                    </div>
                                </div>

                                <div className='row p-2'>
                                    <div className='col-sm-12'>
                                        <Table className='mt-2 small table-sm' striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>List Field</th>
                                                    <th>Enable Multi Select</th>
                                                    <th>List Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {report.CustomFields && report.CustomFields.map((row, index) => (
                                                    <tr key={row.id}>
                                                        <td>{row.FieldName}</td>
                                                        <td><input onChange={(e) => handleOnChangeCustomField(idx, index, { target: { name: "EnableMultiSelect", value: e.currentTarget.checked } }, "CustomFields")} checked={row.EnableMultiSelect || false} type='checkbox' name='EnableMultiSelect' /></td>
                                                        <td>
                                                            <Select
                                                                showSearch
                                                                placeholder="Select List"
                                                                value={row.ListName || []}
                                                                onChange={(values, all) => handleOnChangeCustomField(idx, index, { target: { name: 'ListName', value: values } }, "CustomFields")}
                                                                style={{ width: '100%' }}
                                                                options={
                                                                    row.DataType === "time_based_input"
                                                                        ? RuleData && RuleData.length > 0
                                                                            ? RuleData.map(one => ({ label: one.RuleName, value: one.RuleName }))
                                                                            : []
                                                                        : listData
                                                                }
                                                            />

                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                        {/* <Table className='mt-2 small table-sm' striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Constant Field</th>
                                                <th>Display For Data Entry</th>
                                                <th>Data</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {report.ConstantFields && report.ConstantFields.map((row, index) => (
                                                <tr key={row.id}>
                                                    <td>{row.FieldName}</td>
                                                    <td><input onChange={(e) => handleOnChangeCustomField(idx, index, { target: { name: "DisplayForDataEntry", value: e.currentTarget.checked } }, "ConstantFields")} checked={row.DisplayForDataEntry || false} type='checkbox' name='DisplayForDataEntry' /></td>
                                                    <td>
                                                        <input value={row.Value} placeholder={`Enter ${row.FieldName}...`} step={row.DataType == "float" ? "0.01" : ""} className='form-control form-control-sm' type={row.DataType == "string" ? "text" : row.DataType} name='Value' onChange={(e) => handleOnChangeCustomField(idx, index, { target: { name: 'Value', value: e.currentTarget.value } }, "ConstantFields")} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table> */}

                                    </div>
                                </div>
                            </div>
                        })}
                </div>

            </div>
            <div className='row justify-content-center mt-4'>
                <div className='col-sm-3 text-center'>
                    <button onClick={() => {
                        if (location.state && location.state.action === 'edit') {
                            handleUpdate();
                        } else {
                            handleSave();
                        }
                    }} className="btn btn-sm btn-primary">Save</button>
                    <button onClick={() => history.push('/setting/item/list')} className="btn btn-sm btn-primary ml-2">Cancel</button>
                </div>
            </div>

        </React.Fragment>
    );
}
export default ItemForm;